import Popover from 'antd/lib/popover'

import 'antd/lib/popover/style'

export * from 'antd/lib/popover'

export default Popover
